export default __webpack_public_path__ + "static/media/expand.d3447a72.svg";